export default {
  'dashboard.dispatched_order_summary.number_of_orders': 'Number of Orders',
  'dashboard.dispatched_order_summary.number_of_dispatched_orders': 'Number of Dispatched Orders',
  'dashboard.dispatched_order_summary.order_date': 'Date',
  'dashboard.today_pending_orders': 'Pending Orders',
  'dashboard.today_packed_orders': 'Packed Orders',
  'dashboard.today_dispatched_orders': 'Dispatched Orders',
};
